import React from 'react';
import {MdOutlineCorporateFare} from 'react-icons/md';
import Dropdown from 'react-bootstrap/Dropdown';
import './ObjectIconFilter.css';
import { IoChevronDown } from 'react-icons/io5';
import classnames from 'classnames';


export default function ObjectIconFilter({icon = <MdOutlineCorporateFare />, title, types, selectedType, onChangeType}) {
	return (
		<div className='object-icon-filter'>
			<div className='icon'>{icon}</div>
			<div className='caption-filter'>
				<span className='caption-text'>{title}</span>
				<div className={classnames('filter', {invisible: !types || types.length === 0})}>
					
					<Dropdown>
						<>
							<Dropdown.Toggle className='object-icon-filter-dropdown'>
								<div className="label">
									{types?.find(type => type.value === selectedType)?.label}
								</div>
								<div className="chevron">
									<IoChevronDown  />
								</div>							
							</Dropdown.Toggle>

							<Dropdown.Menu>
								{types?.map((type, index) => (
									<Dropdown.Item key={index} onClick={() => onChangeType(type.value)}>
										{type.label}
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</>
					</Dropdown>
				</div>
			</div>
		</div>
	);
}
